import View from './View'
import store from '../store'
import { Provider } from 'react-redux'
import { ConfigProvider } from 'antd'
import ReactGA4 from 'react-ga4'
import Constants from '../const/Constants'

ReactGA4.initialize(Constants.GOOGLE_ANALYTICS_ID)

const antdTheme = {
    token: {
        colorPrimary: '#2aa9e0',
        colorSuccess: '#52c41a',
        colorError: '#ff4d4f',
        colorWarning: '#faad14',
        colorInfo: '#2aa9e0',
        colorBgContainer: '#ffffff',
        colorBgLayout: '#f5f3f0',
        colorBgElevated: '#ffffff',
        colorBorder: '#e3ddd7',
        colorBorderSecondary: '#e9e5e0',
        colorText: '#2a2420',
        colorTextSecondary: '#5c524a',
        colorTextTertiary: '#756a62',
        colorTextQuaternary: '#b5aba2',
        borderRadius: 8,
        borderRadiusLG: 12,
        borderRadiusSM: 4,
        fontFamily: 'Source Sans Pro, sans-serif',
        colorLink: '#2aa9e0',
        colorLinkHover: '#73c9f8',
        boxShadow: '0 2px 12px rgba(42, 36, 32, 0.07)',
        boxShadowSecondary: '0 4px 12px rgba(42, 36, 32, 0.09)',
    },
}

const App = () => {

    return (
        <Provider store={store}>
            <ConfigProvider theme={antdTheme}>
                <View />
            </ConfigProvider>
        </Provider>
    )
}
export default App
